import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Quote } from "lucide-react";
import { fetchCases, resolveMediaUrl } from "@/lib/api";
import { CASES_TESTS } from "@/constants/testIds";
import PageHero from "@/components/PageHero";
import SEO from "@/components/SEO";

export default function Cases() {
  const [cases, setCases] = useState([]);
  useEffect(() => { fetchCases().then(setCases).catch(() => {}); }, []);

  return (
    <div className="pb-24">
      <SEO
        title="Casos de Éxito · Equipos Dermo Faciales Asirox en Clínicas Reales"
        description="Resultados medibles de clínicas estéticas y centros de belleza que escalan su negocio con equipos dermo faciales Asirox. +187% facturación media, payback en 9 meses, 98% satisfacción cliente final."
        keywords="casos de éxito clínica estética, ROI equipo dermo facial, rentabilidad aparatología facial, testimonios clínicas estéticas, payback inversión dermo facial, resultados Asirox, facturación clínica estética"
      />
      <PageHero
        overline="Casos de éxito"
        title="Clínicas reales."
        highlight="Cifras reales."
        subtitle="Estos son algunos de los centros que confían en Asirox para escalar su modelo de negocio. Cifras auditadas internamente con sus equipos directivos."
      />
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-6">
          {cases.map((c) => (
            <article
              key={c.id}
              data-testid={CASES_TESTS.card(c.id)}
              className="relative border border-black/15 bg-[#f7ebd9] overflow-hidden card-tilt"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-black">
                <img src={resolveMediaUrl(c.image)} alt={c.clinic_name} className="absolute inset-0 w-full h-full object-cover opacity-90"/>
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/80"/>
                <div className="absolute top-5 left-5 overline overline-on-dark">{c.country}</div>
              </div>
              <div className="p-8">
                <p className="metric-num text-3xl md:text-4xl">{c.metric_headline}</p>
                <Quote size={22} className="text-[#3D1F0A] mt-6" strokeWidth={1.6}/>
                <p className="text-black mt-3 leading-relaxed italic">"{c.quote}"</p>
                <div className="div-line my-6"/>
                <div className="flex justify-between items-end text-sm">
                  <div>
                    <p className="font-bold text-black">{c.person}</p>
                    <p className="text-black/60 text-xs">{c.clinic_name}</p>
                  </div>
                  <p className="text-[#3D1F0A] font-mono text-xs font-bold">{c.machine}</p>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-24 grid grid-cols-1 md:grid-cols-3 gap-6 border-t border-black/15 pt-16">
          {[
            { k: "+187%", v: "facturación media tras 12 meses" },
            { k: "9 meses", v: "payback medio de la inversión" },
            { k: "98%", v: "índice de satisfacción cliente final" },
          ].map((s) => (
            <div key={s.v} className="text-center">
              <p className="metric-num text-5xl md:text-6xl">{s.k}</p>
              <p className="overline mt-4">{s.v}</p>
            </div>
          ))}
        </div>

        <div className="mt-24 border border-black/15 bg-[#f1e3cb] p-10 text-center">
          <h3 className="font-heading text-3xl md:text-4xl font-bold tracking-tight ink-heading">Tu centro puede ser el próximo caso.</h3>
          <p className="text-black/75 mt-4 max-w-xl mx-auto">Recibe un análisis de rentabilidad personalizado en menos de 24h.</p>
          <Link to="/contacto?intent=quote" className="btn-primary mt-8 inline-flex">Solicitar análisis</Link>
        </div>
      </div>
    </div>
  );
}
